export default "__VITE_ASSET__v2vtDL4L__"